export default [
    {
        title: 'Tableau de Bord',
        route: 'dashboard',
        icon: 'HomeIcon',
        module: 'DashBoard',
        profile: ['Admin','AdminSuper','Technician']
    },
    {
        header: 'Équipe',
        module:'hierarchical',
        profile: ['Admin','Hierarchy']
    },
    {
        title: 'Objectifs',
        icon: 'GridIcon',
        route: 'objectif_list',
        module:'hierarchical',
        profile: ['Admin', 'Hierarchy']
    },
    {
        title: 'Evaluations',
         route: 'evaluation_list',
        icon: 'ServerIcon',
        module:'hierarchical',
        profile: ['Admin','Hierarchy']
    },
    // {
    //   title: 'Utilisateur',
    //   icon: 'UsersIcon',
    //   // tag: '3',
    //   tagVariant: 'light-danger',
    //   children: [
    //   ],
    // },


]